import {API, Setup} from '../../Services';

async function TopicData(){
    const token = localStorage.getItem('token');
    let mallId= localStorage.getItem('mallId');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/user_topics`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}

async function MessageData(){
    const token = localStorage.getItem('token');
    let mallId= localStorage.getItem('mallId');
    return API.get(`/messaging/merchant_messages/${mallId?mallId:Setup.default_malls}`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}

async function MessageSeen(messageId){
    const token = localStorage.getItem('token');
    return API.post(`/messaging/merchant_messages/${messageId}/set-as-seen`,{},{ headers: { 'Authorization':  `Bearer ${token}`} });
}

export {TopicData,MessageData,MessageSeen};
